import { MaintenanceWindowPreviewPatchManagementWebComponentSchema } from '../../../../../../maintenanceWindows/maintenanceWindowPreviewPatchManagement/types';
import { PatchManagementModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface PatchManagementFormValue {
  uiSettings: { patchManagement: PatchManagementModule };
}

// additional information
export interface PatchManagementAvailableMaintenanceWindow {
  _id: string;
  name: string;
}

export interface PatchManagementSelectedMaintenanceWindow
  extends MaintenanceWindowPreviewPatchManagementWebComponentSchema {
  _id: string;
}

// searchable keywords
export enum PatchManagementSearchableKeywords {
  PatchManagement = 'PatchManagement',
  PatchWindows = 'PatchWindows',
  PatchReboot = 'PatchReboot',
}
